// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';

export type TabType = "search" | "library" | "scenario";

export interface TabHeaderProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const TabHeader: React.FC<TabHeaderProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="evidence-drawer__tabs" role="tablist" aria-label="Evidence drawer tabs">
      <button
        className={`evidence-drawer__tab-button ${
          activeTab === "search" ? "evidence-drawer__tab-button--active" : ""
        }`}
        onClick={() => onTabChange("search")}
        role="tab"
        aria-selected={activeTab === "search"}
        aria-controls="tabpanel-search"
        id="tab-search"
      >
        Search
      </button>
      <button
        className={`evidence-drawer__tab-button ${
          activeTab === "library" ? "evidence-drawer__tab-button--active" : ""
        }`}
        onClick={() => onTabChange("library")}
        role="tab"
        aria-selected={activeTab === "library"}
        aria-controls="tabpanel-library"
        id="tab-library"
      >
        Library
      </button>
      <button
        className={`evidence-drawer__tab-button ${
          activeTab === "scenario" ? "evidence-drawer__tab-button--active" : ""
        }`}
        onClick={() => onTabChange("scenario")}
        role="tab"
        aria-selected={activeTab === "scenario"}
        aria-controls="tabpanel-scenario"
        id="tab-scenario"
      >
        Scenario
      </button>
    </div>
  );
};

